import React, { useContext, useState, useEffect } from "react";
import { Link, useNavigate, NavLink } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import SearchBar from "./SearchBar"; 
import logoImg from "../assets/logox.png"; 

function Header({ toggleTheme, currentTheme }) { 
  const { user, logout, setUser } = useContext(AuthContext);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (user?.name) {
      const checkNotifs = () => {
        const notifs = JSON.parse(localStorage.getItem(`notifications_${user.name}`) || "[]");
        const unread = notifs.filter(n => !n.read).length;
        setUnreadCount(unread);
      };
      checkNotifs();
      const interval = setInterval(checkNotifs, 10000);
      return () => clearInterval(interval);
    }
  }, [user]);

  // Fonction pour gérer l'upload de l'avatar personnalisé
  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Image = reader.result;
        
        // Mise à jour de l'objet utilisateur
        const updatedUser = { ...user, avatar: base64Image };
        
        // Sauvegarde locale
        localStorage.setItem("user", JSON.stringify(updatedUser));
        
        // Mise à jour de l'état global (évite le chargement infini)
        if (setUser) {
          setUser(updatedUser);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <header className="navbar-premium">
      <div className="navbar-content">
        <div className="navbar-left">
          <Link to="/" className="main-logo">
            <img src={logoImg} alt="Logo" className="logo-img" />
            <span className="logo-text">GAMEPULSE <span className="highlight">HQ</span></span>
          </Link>
          
          {/* La cloche ne s'affiche que si tu es connecté */}
          {user && (
            <Link to="/notifications" className="notif-badge-container">
              <span className="notif-icon">🔔</span>
              {unreadCount > 0 && <span className="notif-count">{unreadCount}</span>}
            </Link>
          )}
        </div>

        <nav className="navbar-center">
          <NavLink to="/" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>ACCUEIL</NavLink>
          <NavLink to="/reviews" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>TESTS</NavLink>
          <NavLink to="/blog" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>BLOG</NavLink>
        </nav>

{/* --- ZONE DROITE UNIQUE : THÈME, RECHERCHE & USER --- */}
        <div className="navbar-right">
          <button onClick={toggleTheme} className="theme-toggle-btn">
            {currentTheme === "dark" ? "☀️" : "🌙"}
          </button>

          <div className="search-outer-wrapper">
            <SearchBar /> 
          </div>

          <div className="user-section">
            {user ? (
              <div className="user-logged-container" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <input type="file" id="avatar-upload" hidden accept="image/*" onChange={handleAvatarChange} />
                <div className="profile-link-nav" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <label htmlFor="avatar-upload" style={{ cursor: 'pointer' }}>
                    <img 
                      src={user.avatar || "/logox.png"} 
                      alt="avatar" 
                      className="mini-avatar" 
                      style={{ width: '35px', height: '35px', borderRadius: '50%', border: '2px solid #ec008c', objectFit: 'cover' }}
                      onError={(e) => e.target.src = "/logox.png"}
                    />
                  </label>
                  <Link to="/profile" className="username-nav" style={{ textDecoration: 'none', color: 'white', fontWeight: 'bold' }}>
                    {user.name?.split(' ')[0] || "Joueur"}
                  </Link>
                </div>
                <button onClick={logout} className="btn-logout-icon" style={{ background: 'none', border: 'none', color: '#ff4d4d', cursor: 'pointer', fontWeight: 'bold' }}>
                  OFF
                </button>
              </div>
            ) : (
              <Link to="/login" className="login-btn-premium">CONNEXION</Link>
            )}
          </div>
        </div> {/* Fermeture unique de navbar-right */}
      </div>
    </header>
  );
}

export default Header;